export default {
    toggleSidebar({ state, commit }) {
        commit('setSidebarCollapsed', !state.isSidebarCollapsed)
    },
    collapseSidebar({ commit }) {
        commit('setSidebarCollapsed', true)
    },
    expandSidebar({ commit }) {
        commit('setSidebarCollapsed', false)
    },
    openMobileMenu({ commit }) {
        commit('setMobileMenuOpen', true)
    },
    closeMobileMenu({ commit }) {
        commit('setMobileMenuOpen', false)
    },
    toggleMobileMenu({ state, commit }) {
        commit('setMobileMenuOpen', !state.isMobileMenuOpen)
    }
}
